import ListAltIcon from "@mui/icons-material/ListAlt";
import ListSpecializations from "./List";
import ShowSpecializations from "./Show/Show";
import CreateSpecializations from "./Create";
import EditSpecializations from "./Edit";
import { SPECIALIZATIONS, SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";

export const resources = {
  isMenu: true,
  icon: <ListAltIcon />,
  name: SpecialistServicePath + SPECIALIZATIONS,
  title: "Специалности",
  list: <ListSpecializations />,
  show: <ShowSpecializations />,
  create: <CreateSpecializations />,
  edit: <EditSpecializations />,
  permission: permissions.canPreviewSpecializations,
  showPermission: permissions.canPreviewSpecializations,
  createPermission: permissions.canManageSpecializations,
  editPermission: permissions.canManageSpecializations,
};
